import React, { Component } from "react";
import { Redirect } from "react-router";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { UserBanks } from "./UserBanks";
import { Avatar } from "@mui/material";
import { UserService, User as UserDto } from "../generated";

export interface State {
  loading: boolean;
  user: UserDto;
  isInvited: boolean;
}

export class User extends Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      loading: true,
      user: undefined,
      isInvited: false,
    };
  }

  async componentDidMount() {
    const r = await UserService.userGetUser();
    if (r.success) {
      this.setState({
        loading: false,
        user: r.user,
      });
    }

    if (!r.success) {
      const r = await UserService.userIsInvited();

      this.setState({
        loading: false,
        isInvited: r,
      });
    }
  }

  render() {
    if (!this.state.user) {
      if (this.state.isInvited) {
        return <Redirect to={`/onboarding`} />;
      } else {
        return <div>&nbsp;</div>;
      }
    }

    return (
      <div>
        <Row>
          <Col lg={4}>
            <div className="border rounded rounded-more overflow-hidden p-5">
              <Avatar
                className="float-right rounded rounded-circle"
                style={{ width: "100px", height: "100px" }}
                alt={this.state.user.firstName + " " + this.state.user.lastName}
                src={this.state.user.imageUrl}
              />
              <div className="d-inline-block pt-3">
                <p style={{ fontSize: "0.75em" }} className="pb-0 mb-0">
                  Name
                </p>
                <h2 className="mb-5">
                  {this.state.user.firstName || this.state.user.lastName ? (
                    this.state.user.firstName + " " + this.state.user.lastName
                  ) : (
                    <span>---</span>
                  )}
                </h2>
              </div>
              <p className="mb-4">
                <span style={{ fontSize: "0.75em" }}>Email</span>
                <br />
                {this.state.user.email}
              </p>
              <p className="mb-4">
                <span style={{ fontSize: "0.75em" }}>Phone number</span>
                <br />
                {this.state.user.telephone}
              </p>
              <p className="mb-4">
                <span style={{ fontSize: "0.75em" }}>Country</span>
                <br />
                {this.state.user.country}
              </p>
              <p className="mb-4">
                <span style={{ fontSize: "0.75em" }}>Town</span>
                <br />
                {this.state.user.town}
              </p>
              <p className="mb-4">
                <span style={{ fontSize: "0.75em" }}>Notes</span>
                <br />
                {this.state.user.notes}
              </p>
              <Link className="btn btn-primary mt-3 px-4" to="/user/edit">
                Update profile
              </Link>
            </div>
          </Col>
          <Col lg={8} className="mt-4 mt-lg-0">
            <UserBanks />
          </Col>
        </Row>
      </div>
    );
  }
}
